import { render, staticRenderFns } from "./BuscadorFacturacion.vue?vue&type=template&id=22c0f526&"
import script from "./BuscadorFacturacion.vue?vue&type=script&lang=ts&"
export * from "./BuscadorFacturacion.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('22c0f526', component.options)
    } else {
      api.reload('22c0f526', component.options)
    }
    module.hot.accept("./BuscadorFacturacion.vue?vue&type=template&id=22c0f526&", function () {
      api.rerender('22c0f526', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pantallas/Facturacion/BuscadorFacturacion.vue"
export default component.exports